// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-box {
  display: inline-block;
}

.full-width {
  max-width: 100%;
  text-align: left;
}

.grid-dob {
  text-align: left;
  display: contents;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/reset-password/reset-password-mfa-second-step/reset-password-mfa-second-step.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;AACJ;;AAEE;EACE,gBAAA;EACA,iBAAA;AACJ","sourcesContent":[".logo-box {\r\n    display:inline-block;\r\n}\r\n\r\n.full-width {\r\n    max-width: 100%;\r\n    text-align: left;\r\n  }\r\n\r\n  .grid-dob {\r\n    text-align: left;\r\n    display: contents;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
